import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import {Observable, PureComputed, Subscribable} from 'knockout';
import { IWCCStorageManager } from 'managers/iStorage';
import { EffectsContainer } from 'mixins/withEffects';
import { ServicesContext } from 'services/context';

import './replySuggestion.html';
import autobind from "decorators/autobind";

interface IReplySuggestionConfig {
    threadId: string
    cCanHaveSuggestionsUI: PureComputed<boolean>
    cHasModReply: PureComputed<boolean>
    cReplyContent: PureComputed<Observable<string> | undefined>
    oReplySuggestion: Observable<string | undefined>
    oTranslatedReplySuggestion: Observable<string | undefined>
    oTranslationNeeded: Subscribable<boolean>
    ref: Observable<ReplySuggestion>
}

@injectable()
export default class ReplySuggestion {

    isOpenAiEnabled: boolean;
    threadId: string;

    cCanHaveSuggestionsUI: PureComputed<boolean>;
    cHasModReply: PureComputed<boolean>;
    cReplyContent: PureComputed<Observable<string> | undefined>;
    oReplySuggestion: Observable<string | undefined>;
    oTranslatedReplySuggestion: Observable<string | undefined>;

    replySuggestions = ko.observableArray();
    openAiCompletionRef = ko.observable(null);

    oTranslationNeeded: Subscribable<boolean>
    
    constructor(
        @inject(wccModules.componentConfig) model: IReplySuggestionConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.storage) storage: IWCCStorageManager,
        @inject(wccModules.servicesContext) ctx: ServicesContext,
        @inject(wccModules.effects) effects: EffectsContainer
    ) {
        this.isOpenAiEnabled = WCC.Settings.CurrentUser.IsModerator && WCC.Settings.EnableQualzyAI;
        this.threadId = ko.unwrap(model.threadId);        
        
        this.cCanHaveSuggestionsUI = model.cCanHaveSuggestionsUI;
        this.cHasModReply = model.cHasModReply;
        this.cReplyContent = model.cReplyContent;
        this.oReplySuggestion = model.oReplySuggestion;
        this.oTranslatedReplySuggestion = model.oTranslatedReplySuggestion;
        this.oTranslationNeeded = model.oTranslationNeeded;
        
        model.ref(this);
    }
    
    @autobind
    onOpenAiCompletionReady(completion: string, translatedCompletion: string) {
        const contentField = this.cReplyContent();
        if(contentField) {
            if(WCC.Settings.NotNativeSpeaker === true) {
                contentField(translatedCompletion ? translatedCompletion : completion);
                this.oReplySuggestion(completion);
                this.oTranslatedReplySuggestion(translatedCompletion);
            }
            else {
                contentField(completion);
            }
        }
    }
}